import React, { useState } from "react";
import { VLE } from "@iibf/shared-resources/models/db";
import usePromise from "./usePromise";
import { getCookieObject } from "../cookie";
import { services } from "../../services";
import { setAccessToken } from "../../services/request";
import { TokenPayload } from "@iibf/shared-resources/models/auth/index";

export type AuthState = { is_authenticated: boolean } & Partial<{
  access_token: string;
  vle: Pick<VLE, "id" | "cscId" | "email" | "name"> & {
    State: { id: number; name: string };
    District: { id: number; name: string };
  };
}>;

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>({
    is_authenticated: false,
  });

  const { loading: validatingToken, error } = usePromise(
    {
      fn: async () => {
        const { access_token: accessToken } = getCookieObject();
        const cookieValidationResponse = await services.requestSvc
          .post<{
            actor: {
              id: number;
              cscId: string;
              email: string;
              name: string;
              State: { id: number; name: string };
              District: { id: number; name: string };
            };
            tokenPayload: TokenPayload;
          }>(
            "/validate-token",
            {
              source: "vle",
            },

            {
              headers: { Authorization: "Bearer " + accessToken },
            }
          )
          .catch(console.error);

        if (cookieValidationResponse) {
          Object.assign(authState, {
            is_authenticated: true,
            access_token: accessToken,
            vle: {
              id: BigInt(cookieValidationResponse.actor.id),
              email: cookieValidationResponse.actor.email,
              cscId: cookieValidationResponse.actor.cscId,
              name: cookieValidationResponse.actor.name,
              State: cookieValidationResponse.actor.State,
              District: cookieValidationResponse.actor.District,
            },
          });
        } else {
          Object.assign(authState, {
            is_authenticated: false,
            access_token: undefined,
            vle: undefined,
          });
        }
        setAccessToken(accessToken);
        setAuthState({ ...authState });
      },
      runOnMount: { args: [] },
    },
    []
  );

  if (error) console.log(error);

  return { authState, validatingToken };
}
